import React, { FC } from 'react'
import { FormRow, FormRowContent, FormRowLabel, i18n, Indent } from 'LibNeo'
import { IconComponent } from 'LibNeo/components'
import { UISizes, UITypes } from 'LibNeo/constants/UIConstants'

type ComponentProps = {
	isString?: boolean
	label: string
	tooltip?: string
	vertical?: boolean
}

export const FormRowComponent: FC<ComponentProps> = ({
	children,
	label,
	tooltip,
	isString,
	vertical,
}) => {
	const title = label ? i18n(label) : null
	const iconTooltip = tooltip ? i18n(tooltip) : null
	return (
		<FormRow vertical={vertical}>
			<FormRowLabel isString={isString}>
				{title}
				{Boolean(iconTooltip) && (
					<Indent left={2}>
						<IconComponent
							type={UITypes.PASSIVE}
							name="question-mark-circle-outline"
							tooltip={iconTooltip}
							size={UISizes.SMALL}
						/>
					</Indent>
				)}
			</FormRowLabel>
			<FormRowContent isString={isString} vertical={vertical}>
				{children}
			</FormRowContent>
		</FormRow>
	)
}
